import AES from "crypto-js/aes";
import CryptoJS from "crypto-js/core";
//import {logError , logInfo} from "@/utilities/Filesystem";


const KEY = "8cc44c04f1b3fd0ce243a84e709027e0";

export function decrypt(value: any): any {
    return AES.decrypt(value, KEY);
}

export function encrypt(value: any): any {
    return AES.encrypt(value, KEY);
}

export function encryptEntry(objectToEncrypt: any, arrayToEncrypt = [] as any, keyNameForArray = ""): any {
    let encryptedObject = {} as any;
    for (const key in objectToEncrypt) {
        if (key !== keyNameForArray) {
            if (key === "tabContentImages" || key === "tabImages" || key === "resources" || key === "resourceLinks" || key === "tabAttachedResources" || key === "resourceFiles") {
                const encryptyedValue = encrypt(JSON.stringify(objectToEncrypt[key])).toString();
                encryptedObject = { ...encryptedObject, [encrypt(key).toString()]: encryptyedValue };
            } else if (key !== "id" && key !== "journeySetId" && key !== "quadrantId" && key !== "js89sd8lsDKf3" && key !== 'locale') {
                if (objectToEncrypt[key] !== undefined) {
                    const encryptyedValue = encrypt(objectToEncrypt[key]?.toString()).toString();
                    encryptedObject = { ...encryptedObject, [encrypt(key).toString()]: encryptyedValue };
                }
            } else {
                encryptedObject = { ...encryptedObject, [key]: objectToEncrypt[key] };
            }
        }
    }

    if (arrayToEncrypt.length > 0) {
        let encryptedArray = [] as any;
        for (const currentTab of arrayToEncrypt) {
            let encryptedObjectForArray = {};
            for (const key in currentTab) {
                if (currentTab[key]) {
                    const rawValue = currentTab[key];
                    const shouldJsonEncode = key === "tabAttachedResources";
                    const valueToEncrypt = shouldJsonEncode ? JSON.stringify(rawValue) : rawValue.toString();
                    const encryptyedValue = encrypt(valueToEncrypt).toString();
                    encryptedObjectForArray = { ...encryptedObjectForArray, [encrypt(key).toString()]: encryptyedValue };
                }
            }
            encryptedArray = [encryptedObjectForArray, ...encryptedArray];
        }
        encryptedObject = { ...encryptedObject, [keyNameForArray]: encryptedArray };
    }
    return encryptedObject;
}

export function decryptEntry(objectToDecrypt: any, arrayToDecrypt = [] as any, keyNameForArray = "") {
    let decryptedObject = {} as any;
    for (const key in objectToDecrypt) {
        
        if (key !== keyNameForArray) {
            
            if (key !== "id" && key !== "journeySetId" && key !== "quadrantId" &&  key !== "js89sd8lsDKf3" && key !== 'locale' && key !=="resources") {
                if (objectToDecrypt[key]) {
                    try{
                        
                        let decryptedValue = decrypt(objectToDecrypt[key]).toString(CryptoJS.enc.Utf8);

                        if (decryptedValue === "false" || decryptedValue === "true") {
                            decryptedValue = JSON.parse(decryptedValue);
                        } else if (["order", "tabContentImages", "tabImages" , "resources", "tabAttachedResources", "resourceFiles"].includes(decrypt(key).toString(CryptoJS.enc.Utf8))) {
                            try{
                                decryptedValue = JSON.parse(decryptedValue);
                            } catch(e: any) {
                                throw new Error( "Error while parsing: " + decryptedValue);
                            }
                        }
                        decryptedObject = { ...decryptedObject, [decrypt(key).toString(CryptoJS.enc.Utf8)]: decryptedValue };
                    } catch(e: any) {
                        throw new Error("Error while decrypting key " + key );
                    }
                }
            } else {
                decryptedObject = { ...decryptedObject, [key]: objectToDecrypt[key] };
            }
        }
    }
    if (arrayToDecrypt.length > 0) {
        let decryptedArray = [] as any;
        for (const currentIndex of arrayToDecrypt) {
            let decryptedObjectForArray = {};
            for (const key in currentIndex) {
                if (currentIndex[key]) {
                    const decryptedKey = decrypt(key).toString(CryptoJS.enc.Utf8);
                    let decryptedValue: any = decrypt(currentIndex[key]).toString(CryptoJS.enc.Utf8);
                    if (decryptedKey === "tabAttachedResources") {
                        try {
                            decryptedValue = JSON.parse(decryptedValue);
                        } catch {
                            // Leave as-is if parsing fails
                        }
                    }
                    decryptedObjectForArray = { ...decryptedObjectForArray, [decryptedKey]: decryptedValue };
                }
            }

            decryptedArray = [decryptedObjectForArray, ...decryptedArray];
        }
        decryptedObject = { ...decryptedObject, [keyNameForArray]: decryptedArray };
    }
    return decryptedObject;
}

export function encryptManifestFile(locale: any, fileData:string){
    const encryptedLocale = AES.encrypt(JSON.stringify(locale), KEY).toString()
    const encryptedManifestData = AES.encrypt(fileData ,KEY).toString();
    const fileObject = JSON.stringify({
        "locale": encryptedLocale,
        "content": encryptedManifestData
    })
    return fileObject;
}

export function encryptQuadrants(quadrantsString: string) {
    const quadrantStringArray = quadrantsString.match(/.{1,5000000}/g) ?? [];
    return quadrantStringArray.map((chunk) => AES.encrypt(JSON.stringify(chunk), KEY).toString())
}